import axios from './axios';

export const subscriptionsAPI = {
  // ─── Dashboard Summaries ────────────────────────────────────────────────────
  getDashboardSummary: async () => {
    const response = await axios.get('/subscriptions/dashboard/summary');
    return response.data;
  },

  getPlansSummary: async () => {
    const response = await axios.get('/subscriptions/plans/dashboard/summary');
    return response.data;
  },

  // ─── Subscription Plans ─────────────────────────────────────────────────────
  createPlan: async (data) => {
    const response = await axios.post('/subscriptions/plans', data);
    return response.data;
  },

  getPlans: async (params) => {
    const response = await axios.get('/subscriptions/plans', { params });
    return response.data;
  },

  // Alias for backward compatibility
  getAllPlans: async (params) => {
    const response = await axios.get('/subscriptions/plans', { params });
    return response.data;
  },

  getPlanById: async (id) => {
    const response = await axios.get(`/subscriptions/plans/${id}`);
    return response.data;
  },

  updatePlan: async (id, data) => {
    const response = await axios.put(`/subscriptions/plans/${id}`, data);
    return response.data;
  },

  deletePlan: async (id) => {
    const response = await axios.delete(`/subscriptions/plans/${id}`);
    return response.data;
  },

  // ─── Customer Subscriptions ─────────────────────────────────────────────────
  purchase: async (data) => {
    const response = await axios.post('/subscriptions/purchase', data);
    return response.data;
  },

  // Alias for backward compatibility
  purchaseSubscription: async (data) => {
    const response = await axios.post('/subscriptions/purchase', data);
    return response.data;
  },

  getAll: async (params) => {
    const response = await axios.get('/subscriptions', { params });
    return response.data;
  },

  // Alias for backward compatibility
  getAllSubscriptions: async (params) => {
    const response = await axios.get('/subscriptions', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await axios.get(`/subscriptions/${id}`);
    return response.data;
  },

  cancel: async (id, data) => {
    const response = await axios.patch(`/subscriptions/${id}/cancel`, data);
    return response.data;
  },

  // Alias for backward compatibility
  cancelSubscription: async (id, data) => {
    const response = await axios.patch(`/subscriptions/${id}/cancel`, data);
    return response.data;
  },

  // ─── Additional Helper Methods ──────────────────────────────────────────────
  getCustomerSubscriptions: async (customerId, params) => {
    const response = await axios.get('/subscriptions', {
      params: { ...params, customerId }
    });
    return response.data;
  },

  getActiveSubscription: async (customerId) => {
    const response = await axios.get('/subscriptions', {
      params: { customerId, status: 'active', limit: 1 }
    });
    return response.data;
  },

  // Cashier helper: look up the active subscription for a phone number.
  lookupByPhone: async (phone) => {
    const response = await axios.get(`/subscriptions/lookup/phone/${encodeURIComponent(phone)}`);
    return response.data;
  },
};
